import { IntegrityMonitorFileRuleFormWebComponent } from './component/IntegrityMonitorFileRuleFormWebComponent';
import { WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_FILE_FORM } from '../../../../webcomponents.constants';

export { IntegrityMonitorFileRuleFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_FILE_FORM,
  IntegrityMonitorFileRuleFormWebComponent
);
